export default __webpack_public_path__ + "df1c21d8a38e7854b625becf94f495d6.svg";